export default "__VITE_ASSET__16fb395a__"